/**
 * product-metafield-addons.js
 * Checkbox add-ons from product.metafields.custom.add_on_products
 */
(function () {
  'use strict';

  var container = document.querySelector('[data-pdp-addons]');
  if (!container) return;

  var productId = container.getAttribute('data-product-id');

  function getForm() {
    return document.querySelector('form.product-single__form');
  }

  function getMainVariantId() {
    var form = getForm();
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function ensureQuantityOne() {
    var form = getForm();
    if (!form) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = '1';
    }
  }

  function getSelectedAddonItems() {
    var items = [];
    container.querySelectorAll('.pdp-addons__input:checked').forEach(function (input) {
      var variantId = parseInt(input.value, 10);
      if (variantId > 0) {
        items.push({ id: variantId, quantity: 1 });
      }
    });
    return items;
  }

  function isDynamicCheckoutSubmitter(submitter) {
    if (!submitter) return false;
    return Boolean(
      submitter.closest('.shopify-payment-button') ||
      submitter.matches('.shopify-payment-button__button') ||
      submitter.matches('[data-shopify="payment-button"] button') ||
      submitter.getAttribute('name') === 'checkout'
    );
  }

  function openCartDrawer(form) {
    form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      bubbles: true,
      detail: { addToCartBtn: form.querySelector('[data-add-to-cart]') }
    }));
  }

  function addItemsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || 'Cart error');
        });
      }
      return res.json();
    });
  }

  function buildCartItems() {
    ensureQuantityOne();
    var mainId = getMainVariantId();
    var items = mainId ? [{ id: mainId, quantity: 1 }] : [];
    return items.concat(getSelectedAddonItems());
  }

  function bindVariantSelects() {
    container.querySelectorAll('.pdp-addons__variant').forEach(function (select) {
      if (select.dataset.pdpAddonsBound === 'true') return;
      select.dataset.pdpAddonsBound = 'true';

      select.addEventListener('change', function () {
        var input = document.getElementById(select.getAttribute('data-input-id'));
        if (!input) return;
        var option = select.options[select.selectedIndex];
        if (!option || option.disabled) return;
        input.value = option.value;
        input.dataset.price = option.getAttribute('data-price') || '0';
        var row = input.closest('.pdp-addons__row');
        var priceEl = row && row.querySelector('.pdp-addons__price');
        if (priceEl && option.getAttribute('data-price-formatted')) {
          priceEl.textContent = option.getAttribute('data-price-formatted');
        }

        var link = row && row.querySelector('[data-pdp-addon-link]');
        var productUrl = select.getAttribute('data-product-url');
        if (link && productUrl) {
          link.href = productUrl + '?variant=' + option.value;
        }
      });
    });
  }

  var inFlight = false;

  function handleSubmit(e) {
    var addons = getSelectedAddonItems();
    if (!addons.length) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (inFlight) return;
    inFlight = true;

    var form = getForm();
    var btn = form && form.querySelector('[data-add-to-cart]');
    var btnText = btn && btn.querySelector('[data-add-to-cart-text]');
    var originalText = btnText ? btnText.textContent : '';
    if (btn) btn.disabled = true;
    if (btnText) btnText.textContent = 'Adding...';

    var goCheckout = isDynamicCheckoutSubmitter(e.submitter);

    addItemsToCart(buildCartItems())
      .then(function () {
        if (goCheckout) {
          window.location.assign('/checkout');
          return;
        }
        if (btnText) btnText.textContent = originalText;
        if (btn) btn.disabled = false;
        if (form) openCartDrawer(form);
      })
      .catch(function (err) {
        console.error('[product-metafield-addons]', err);
        alert(err.message || 'Something went wrong. Please try again.');
        if (btnText) btnText.textContent = originalText;
        if (btn) btn.disabled = false;
      })
      .finally(function () {
        inFlight = false;
      });
  }

  function bindForm() {
    var form = getForm();
    if (!form || form.dataset.pdpAddonsBound === 'true') return;
    form.dataset.pdpAddonsBound = 'true';

    form.addEventListener('submit', handleSubmit, true);

    document.addEventListener('click', function (e) {
      var paymentWrap = e.target.closest('.shopify-payment-button');
      if (!paymentWrap) return;
      if (!getSelectedAddonItems().length) return;

      var fakeEvent = {
        preventDefault: function () { e.preventDefault(); },
        stopImmediatePropagation: function () { e.stopImmediatePropagation(); },
        submitter: e.target.closest('button') || e.target
      };
      handleSubmit(fakeEvent);
    }, true);
  }

  bindVariantSelects();
  bindForm();
  ensureQuantityOne();

  document.addEventListener('variant:changed', function () {
    setTimeout(function () {
      var form = getForm();
      if (form) delete form.dataset.pdpAddonsBound;
      bindForm();
      ensureQuantityOne();
    }, 300);
  });
})();
